import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import '../style.css';

const BannerSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Local banner images from public folder
  const banners = [
    {
      id: 1,
      image: "/banner.png"
    },
    {
      id: 2,
      image: "/banner1.png"
    },
    
 
  ];

  // Fast auto slide change every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, [banners.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % banners.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="banner-section">
      <div className="banner-container">
        {/* Banner Images with Background Cover */}
        <div className="banner-images">
          {banners.map((banner, index) => (
            <div 
              key={banner.id}
              className={`banner-slide ${index === currentSlide ? 'active' : ''}`}
              style={{ 
                backgroundImage: `url(${banner.image})`
              }}
            />
          ))}
        </div>
        
      
      </div>
    </section>
  );
};

export default BannerSection;